import { REPORTSUMMARYCSV_SUCCESS, REPORTSUMMARYCSV_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryCsvReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYCSV_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYCSV_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryCsvReducer;
